import React from 'react';
import { createSelector } from 'reselect';
import FormControl from '@material-ui/core/FormControl';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import lodash from 'lodash';
import { BANKS } from '../../../@types/model/bankAccount';

interface IBankDropdownProps {
    id ?: string;
    value ?: string;

    onChange : (value ?: string) => void;

    required ?: boolean;
    autoFocus ?: boolean;

    fullWidth ?: boolean;

    label ?: string;
}

interface IBankDropdownState {
}

export default class BankDropdown extends React.Component<IBankDropdownProps, IBankDropdownState> {
    constructor(props : IBankDropdownProps) {
        super(props);

        this.state = {
        };
    }

    private readonly onChange = (event : React.ChangeEvent<unknown>, value : {
        label : string;
        value : string;
    } | null) => {
        if (typeof value === 'string') {
            this.props.onChange(value);
        } else {
            this.props.onChange(value?.value);
        }
    };

    private readonly getValue = (state : IBankDropdownState, props : IBankDropdownProps) => props.value;
    private readonly getRequired = (state : IBankDropdownState, props : IBankDropdownProps) => props.required;

    private readonly getBankDropdown = createSelector([
        this.getRequired,
    ], (required) => {
        const drop = lodash.map(BANKS, (n) => ({ label: n, value: n }));

        if (!required) {
            drop.unshift({
                label: 'ALL',
                value: '',
            });
        }

        return drop;
    });

    private readonly getSelectedValue = createSelector([
        this.getValue, this.getRequired,
    ], (value, required) => {
        if (value) {
            const bank = BANKS.find(x => x === value);

            if (bank) {
                return { label: bank, value: bank };
            } else {
                return { label: value, value };
            }
        }

        if (!value && !required) {
            return {
                label: 'ALL',
                value: '',
            };
        }

        return null;
    });

    public readonly render = () => {
        const { required, fullWidth, id, label = 'Bank' } = this.props;

        const dropdown = this.getBankDropdown(this.state, this.props);

        const value = this.getSelectedValue(this.state, this.props);
        return (
            <FormControl fullWidth={fullWidth} error={required && !value} required={required}>
                <Autocomplete
                    id={id}
                    options={dropdown}
                    value={value}
                    getOptionSelected={(option, val) => option.value === val.value}
                    getOptionLabel={option => option.label}
                    onChange={this.onChange}
                    disableClearable={required}
                    openOnFocus
                    renderInput={params => <TextField error={required && !value} {...params} fullWidth={fullWidth} label={label} />}
                />
                {
                    required && !value &&
                    <FormHelperText error>Required</FormHelperText>
                }
                <div className='wfill' style={{
                    minHeight: 8,
                }}>
                </div>
            </FormControl>
        );
    };
}
